import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow4Directions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_199_811)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.1299 6.5945C15.7532 6.21776 15.1444 6.21776 14.7677 6.5945C14.391 6.97123 14.391 7.57996 14.7677 7.9567L15.8468 9.03581L10.9642 9.03581L10.9642 4.15318L12.0433 5.2323C12.42 5.60903 13.0288 5.60903 13.4055 5.2323C13.7822 4.85556 13.7822 4.24683 13.4055 3.8701L10.6811 1.1457C10.3044 0.768966 9.69563 0.768966 9.3189 1.1457L6.5945 3.8701C6.21777 4.24683 6.21777 4.85556 6.5945 5.2323C6.97123 5.60903 7.57997 5.60903 7.9567 5.2323L9.03582 4.15318L9.03582 9.03581L4.15318 9.03581L5.2323 7.9567C5.60903 7.57996 5.60904 6.97123 5.2323 6.5945C4.85557 6.21776 4.24684 6.21776 3.8701 6.5945L1.1457 9.3189C0.76897 9.69563 0.76897 10.3044 1.1457 10.6811L3.8701 13.4055C4.24684 13.7822 4.85557 13.7822 5.2323 13.4055C5.60904 13.0288 5.60904 12.42 5.2323 12.0433L4.15318 10.9642L9.03582 10.9642L9.03582 15.8468L7.9567 14.7677C7.57997 14.391 6.97123 14.391 6.5945 14.7677C6.21777 15.1444 6.21777 15.7532 6.5945 16.1299L9.3189 18.8543C9.69563 19.231 10.3044 19.231 10.6811 18.8543L13.4055 16.1299C13.7822 15.7532 13.7822 15.1444 13.4055 14.7677C13.0288 14.391 12.42 14.391 12.0433 14.7677L10.9642 15.8468L10.9642 10.9642L15.8468 10.9642L14.7677 12.0433C14.391 12.42 14.391 13.0288 14.7677 13.4055C15.1444 13.7822 15.7532 13.7822 16.1299 13.4055L18.8543 10.6811C19.231 10.3044 19.231 9.69563 18.8543 9.3189L16.1299 6.5945Z",
			fill: "#0D2976"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_199_811",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "matrix(1 0 0 -1 0 20)"
		})
	}) })]
});
export default SvgArrow4Directions;
